import { decimalTo } from "../../utils/utils";

export const OrderReportColumns = (viewOrder) => [
  { name: "ID", selector: row => row.orderId, width: "80px" },

  {
    name: "Order Date",
    cell: row => new Date(row.orderDate).toLocaleString(),
    width: "120px",
  },
  {
    name: "Merchant",
    selector: row => row.merchentName,
    wrap: true,
  },
  { name: "Order ID", selector: row => row.orderNo },
  {
    name: "Products",
    selector: row => row.ordersItems,
    wrap: true,
  },
  { name: "State", selector: row => row.paymentZone, width: "80px" },
  { name: "Qty", selector: row => row.ordersQuantity, width: "60px" },

  {
    name: "Total Amount",
    cell: row => decimalTo(row.orderAmount).toFixed(2),
  },
  {
    name: "D.MRP",
    cell: row => decimalTo(row.vendorAmount).toFixed(2),
  },
  {
    name: "Margin",
    cell: row => decimalTo(row.savingAmount).toFixed(2),
  },
  {
    name: "Net Amount",
    cell: row => decimalTo(row.netAmount).toFixed(2),
  },
  {
    name: "Status",
    selector: row => row.status,
  },
  {
    name: "Action",
    cell: row => (
      <button
        className="btn btn-sm btn-info px-3"
        onClick={() => viewOrder(row.orderId)}
      >
        View
      </button>
    ),
    ignoreRowClick: true,
  
  }
];
